import { Component, createRef } from 'react'
import Form from "react-bootstrap/Form"
import withRouter from '../components/withRouter'
import TopMenu from '../components/topmenu'
import Logo from '../images/hit_logo.png'
import Banner from '../images/banner.png'
import axios from 'axios'
import moment from 'moment'
import { TfiReload, TfiShortcode } from 'react-icons/tfi'
import { FaAmbulance, FaClinicMedical, FaHandHoldingMedical, FaArrowCircleLeft, FaArrowCircleRight, FaHome, FaBookMedical, FaRegHospital } from 'react-icons/fa'
import { FaPeopleRoof, FaPrescription, FaBedPulse, FaCalendarDays } from 'react-icons/fa6'
import { MdOutlineSick, MdOutlineMedication, MdOutlinePermMedia, MdMonitor } from 'react-icons/md'
import { LiaFileMedicalAltSolid, LiaProceduresSolid } from 'react-icons/lia'
import { RiHealthBookLine, RiTeamLine } from 'react-icons/ri'
import { TbVaccine, TbReportMedical, TbPhoneCalling, } from 'react-icons/tb'
import { CiMedicalClipboard } from 'react-icons/ci'
import { BsPrescription, BsHospital } from 'react-icons/bs'
import { LuCopy, LuCopyCheck, LuFolderCheck, LuFolderX } from 'react-icons/lu'
import PatientCard from '../components/patientCard'
import Patient from '../components/Patient'
import EncounterBig from '../components/EncounterBig'
import Encounter from '../components/Encounter'
import Condition from '../components/Condition'
import AllergyIntolerance from '../components/AllergyIntolerance'
import Immunization from '../components/Immunization'
import Practitioner from '../components/Practitioner'
import Organization from '../components/Organization'
import PatientSmall from '../components/PatientSmall'
import Observation from '../components/Observation'
import Procedure from '../components/Procedure'
import DiagnosticReport from '../components/DiagnosticReport'
import Device from '../components/Device'
import CareTeam from '../components/CareTeam'
import CarePlan from '../components/CarePlan'
import Coverage from '../components/Coverage'
import Appointment from '../components/Appointment'
import MedicationRequest from '../components/MedicationRequest'
import ServiceRequest from '../components/ServiceRequest'
import TBD from '../components/tbd'
import { PeriodStart, CodeableConcepts, Coding, Period, Hospitalization } from '../helpers'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './all.css'


class Home extends Component {
    constructor(props) {
        super(props)

        this.state = {
            previous: false,
            self: null,
            next: null,
            sort: false,
            name: '',
            mbrid: '',
            patient: null,
            patients: null,
            splash: true,
            bounce: false,
            displayMsg: false,
            msg: '',
            isWorking: false,
            isPreviousing: false,
            isNexting: false,
            total: null,
            encounter: null,
            encounters: null,
            longRec: false,
            qry: null,
            eqry: null,
            servers: ["https://r4.smarthealthit.org",
                "https://hapi.fhir.org/baseR4",
                "https://server.fire.ly",
                "https://wildfhir4.aegis.net/fhir4-0-1"
            ],
            sidx: 0,
            displayServers: false,
            more: [],
            copied: false
        }
        this.handleGetPatient = this.handleGetPatient.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.handlePrefSelected = this.handlePrefSelected.bind(this)
        this.handleGetEncounter = this.handleGetEncounter.bind(this)
    }

    ScrollUp = createRef()

    componentDidMount() {
        if (this.props.isAuthenticated) {
            setTimeout(() => this.setState({ splash: false }), 1000)
        } else {
            this.setState({ splash: false, bounce: true })
            setTimeout(() => {
                this.handleNavigate('login', true)
            }, 3000)
        }
    }

    scrollToRef = ref => {
        ref.current.scroll({
            top: 200,
            behavior: 'smooth'
        })
    }

    handlePrefSelected() {
        this.props.onLogout()
        this.handleNavigate('login')
    }

    handleNavigate(page, history) {
        const { search } = this.props
        if (history) this.props.onAddHistory(search.pathname + search.search)
        const { navigate } = this.props
        navigate(`/${page}`)
    }

    handleBack() {
        this.handleNavigate(``, true)
    }

    handleGetPatient(id, url) {
        const qry = url ? url.url : `${this.state.servers[this.state.sidx]}/Patient/${id}/$everything?_format=json`
        this.setState({ isWorking: url ? false : true, isPreviousing: url && url.relation === 'previous', isNexting: url && url.relation === 'next', encounters: null, eqry: null })
        const pidx = this.state.patient && this.state.patient.entry ? this.state.patient.entry.findIndex(r => r.resource.resourceType === 'Patient') : -1
        axios.get(qry)
            .then(resp => {
                let patient = resp.data
                if (pidx > -1 && patient.entry.findIndex(p => p.resource.resourceType === 'Patient') === -1) patient = { ...patient, entry: [...patient.entry, this.state.patient.entry[pidx]] }
                this.setState({ qry, patient, total: resp.data.entry.length, isWorking: false, isNexting: false, isPreviousing: false, copied: false, more: [], eqry: null })
                setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
            })
            .catch(err => {
                this.setState({ isWorking: false, isPreviousing: false, isNexting: false, msg: err.message, displayMsg: true, eqry: null })
                setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
            })
    }

    handleGetEncounter(id, url) {
        const eqry = url ? url.url : `${this.state.servers[this.state.sidx]}/Encounter/${id}/$everything?_format=json`
        this.setState({ isWorking: url ? false : true, isPreviousing: url && url.relation === 'previous', isNexting: url && url.relation === 'next' })
        const eidx = this.state.encounter && this.state.encounter.entry ? this.state.encounter.entry.findIndex(r => r.resource.resourceType === 'Encounter') : -1
        axios.get(eqry)
            .then(resp => {
                let encounter = resp.data
                if (eidx > -1) encounter = { ...encounter, entry: [...encounter.entry, this.state.encounter.entry[eidx]] }
                this.setState({ eqry, encounter, total: resp.data.entry.length, isWorking: false, isNexting: false, isPreviousing: false, copied: false, more: [] })
                setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
            })
            .catch(err => {
                this.setState({ isWorking: false, isPreviousing: false, isNexting: false, msg: err.message, displayMsg: true })
                setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
            })
    }

    handleChange = event => {
        if (event.target.id === 'name') {
            this.setState({ name: event.target.value.replace(/[^a-zA-Z0-9- ]/g, ""), mbrid: '' })
        } else {
            this.setState({ mbrid: event.target.value.replace(/[^a-zA-Z0-9- ]/g, ""), name: '', sort: false })
        }
    }

    handleCheckChanged(e) {
        this.setState({ [e.target.value]: e.target.checked })
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    handleServerSelected(sidx) {
        this.setState({ sidx, displayServers: false })
    }

    handleDisplayServers() {
        this.setState({ displayServers: true })
    }

    handleBackToList() {
        this.setState({ patient: null, total: this.state.patients.length })
        setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
    }

    handleBackToPatient() {
        this.setState({ encounter: null, eqry: null, total: this.state.patient.entry.length })
    }

    handleMore(res) {
        let idx = this.state.more.indexOf(res)
        let more = this.state.more
        if (idx > -1) {
            more.splice(idx, 1)
        } else more.push(res)
        this.setState({ more })
    }

    handleCopy() {
        this.setState({ copied: true })
        navigator.clipboard.writeText(this.state.qry)
    }

    handleGetPatients(link) {
        if (!this.state.isWorking && !this.state.isPreviousing && !this.state.isNexting) {
            if (link) {
                this.setState({ [link.relation]: link.url, isPreviousing: link.relation === 'previous', isNexting: link.relation === 'next', encounters: null, eqry: null })
            } else this.setState({ isWorking: true, patient: null, encounters: null, eqry: null })
            //console.log(this.state.name, this.state.sort, this.state.mbrid)
            let qry = `${(link ? link.url : null) || `${this.state.servers[this.state.sidx]}/Patient${this.state.sort || this.state.name !== '' ? '?' : ''}${this.state.sort ? '_sort=family' : ''}${this.state.sort && this.state.name ? '&' : ''}${this.state.name !== '' ? `family=${this.state.name}` : ''}${this.state.mbrid !== '' ? `?identifier=${this.state.mbrid}` : ''}`}`
            if (qry.indexOf('?') > -1) {
                qry += "&_format=json"
            } else qry += "?_format=json"
            axios.get(qry)
                .then(resp => {
                    const patients = resp.data.entry || []
                    const links = resp.data.link || null
                    let previous, next, self
                    if (links) {
                        let idx = links.findIndex(l => l.relation === 'previous')
                        if (idx > -1) previous = links[idx]
                        idx = links.findIndex(l => l.relation === 'self')
                        if (idx > -1) self = links[idx]
                        idx = links.findIndex(l => l.relation === 'next')
                        if (idx > -1) next = links[idx]
                    }
                    const total = resp.data.total || patients.length || null
                    this.setState({ patients: patients.length > 0 ? patients : null, previous, next, self, isWorking: false, isPreviousing: false, isNexting: false, patient: null, total, qry, eqry: null })
                    setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
                })
                .catch(err => {
                    this.setState({ isWorking: false, isPreviousing: false, isNexting: false, msg: err.message, displayMsg: true, eqry: null })
                    setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
                })
        }
    }

    handleLongRec() {
        if (!this.state.longRec) {
            if (this.state.patient) {
                this.setState({ working: true, encounters: null })
                let eqry = `${this.state.servers[this.state.sidx]}/Encounter?subject=${this.state.patient.entry[this.state.patient.entry.findIndex(r => r.resource.resourceType === 'Patient')].resource.id}`
                if (eqry.indexOf('?') > -1) {
                    eqry += "&_format=json"
                } else eqry += "?_format=json"
                axios.get(eqry)
                    .then(resp => {
                        this.setState({ total: resp.data.total || (resp.data.entry ? resp.data.entry.length : '0'), encounters: resp.data.entry || [], working: false, longRec: true, eqry })
                    })
                    .catch(err => {
                        this.setState({ isWorking: false, isPreviousing: false, isNexting: false, msg: err.message, displayMsg: true })
                        setTimeout(() => this.scrollToRef(this.ScrollUp), 200)
                    })
            }
        } else this.setState({ longRec: !this.state.longRec, eqry: null })

    }

    handleVerticalElemClick(id) {
        this.handleGetEncounter(id)
    }

    getSplash() {
        return <div className='All-Splash'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
        </div>
    }

    getBounce() {
        return <div className='All-Bounce'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
            <div className='All-Content'>Become part of Interoperability by Logging In or Joining HIT FHIR.</div>
        </div>
    }

    getMessage() {
        return <div className='All-Confirm'>
            <div className='All-Row All-Text'>{this.state.msg}</div>
            <div className="All-Row All-Flex-Wrap">
                <div className='All-Button All-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getServer() {
        return <div className='All-Row All-Flex-Wrap'>{this.state.displayServers ? this.state.servers.map((server, serveridx) => {
            return <div key={`server-${serveridx}`} className='Server-Container' onClick={() => this.handleServerSelected(serveridx)}>{server}</div>
        }) : <div className='Server-Container' onClick={() => this.handleDisplayServers()}>{`Server: ${this.state.servers[this.state.sidx]}`}</div>}</div>
    }

    getIcon(res) {
        switch (res) {
            case 'CarePlan':
                return <RiHealthBookLine />
            case 'CareTeam':
                return <RiTeamLine />
            case 'Condition':
                return <MdOutlineSick />
            case 'ClinicalImpression':
                return <FaHandHoldingMedical />
            case 'Communication':
                return <TbPhoneCalling />
            case 'DiagnosticReport':
                return <TbReportMedical />
            case 'Encounter':
                return <FaPeopleRoof />
            case 'Immunization':
                return <TbVaccine />
            case 'Media':
                return <MdOutlinePermMedia />
            case 'Medication':
                return <MdOutlineMedication />
            case 'MedicationRequest':
                return <FaPrescription />
            case 'MedicationDispense':
                return <BsPrescription />
            case 'Observation':
                return <CiMedicalClipboard />
            case 'Procedure':
                return <LiaProceduresSolid />
            case 'ServiceRequest':
                return <LiaFileMedicalAltSolid />
            default:
                return <FaClinicMedical />
        }
    }

    getEncounterIcon(val) {
        switch (val) {
            case 'ACUTE':
                return <FaRegHospital />
            case 'AMB':
                return <FaClinicMedical />
            case 'EMER':
                return <FaAmbulance />
            case 'IMP':
                return <FaBedPulse />
            case 'VR':
                return <MdMonitor />
            case 'HH':
                return <FaHome />
            case 'SS':
                return <TfiShortcode />
            default:
                return <FaClinicMedical />
        }
    }

    getPatient() {
        if (this.state.patient && this.state.patient.entry) {
            if (this.state.longRec) {
                return <div>
                    <div className='All-Row All-Flex-Wrap'>
                        <div className='All-Button All-Button-Save All-Flex-Wrap' onClick={() => this.handleLongRec()}>
                            <div style={{ textAlign: 'center' }}>{this.state.longRec ? 'Resources View' : 'Chronological View'}</div>
                        </div>
                    </div>
                    <div className='All-Row'>
                        {this.state.encounters && <VerticalTimeline>
                            {
                                this.state.encounters.filter(ee => ee.resource.period).sort((a, b) => {
                                    let x = moment(a.resource.period.start).format('YYYY-MM-DD HH:mm')
                                    let y = moment(b.resource.period.start).format('YYYY-MM-DD HH:mm')
                                    if (x > y) return -1
                                    if (y > x) return 1
                                    return 0
                                }).map((e, eidx) => {
                                    return <VerticalTimelineElement key={`encounter-${eidx}`}
                                        className="vertical-timeline-element--work"
                                        contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                                        contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                                        date={moment(e.resource.period.start).format('ll')}
                                        dateClassName='All-Text-Left'
                                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                                        icon={this.getEncounterIcon(Coding(e.resource.class))}
                                        onTimelineElementClick={() => this.handleVerticalElemClick(e.resource.id)}
                                    >
                                        <h1>{e.resource.type && <div className=''>{CodeableConcepts(e.resource.type)}</div>}</h1>
                                        <div className='Res-Row Res-Flex-Spread'>
                                            <div style={{ marginRight: '5px' }}>
                                                <div className={`Res-Icon ${e.resource.active ? 'Res-Icon-Active' : 'Res-Icon-Inactive'}`}>{e.resource.active ? <LuFolderCheck /> : <LuFolderX />}</div>
                                                <div className='Res-Icon-Label'>{e.resource.active ? 'Active' : "Inactive"}</div>
                                            </div>
                                            <div className='Res-Icon-Big'><FaPeopleRoof /></div>
                                            {e.resource.class && <div><div className='Res-Detail'>{Coding(e.resource.class)}</div><div className='Res-Icon-Label'>Class</div></div>}
                                        </div>
                                        {e.resource.period && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><FaCalendarDays /></div><div className='Res-Detail'>{Period(e.resource.period)}</div></div>}
                                        {e.resource.reasonCode && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><FaBookMedical /></div><div className='Res-Detail'>{CodeableConcepts(e.resource.reasonCode)}</div></div>}
                                        {e.resource.hospitalization && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><BsHospital /></div><div className='Res-Detail'>{Hospitalization(e.resource.hospitalization)}</div></div>}

                                    </VerticalTimelineElement>
                                })
                            }
                        </VerticalTimeline>}
                    </div>
                </div>
            } else {
                let resources = {}
                this.state.patient.entry.forEach(res => {
                    if (resources[res.resource.resourceType]) {
                        resources[res.resource.resourceType].push(res.resource)
                    } else {
                        resources[res.resource.resourceType] = [res.resource]
                    }
                    if (resources.Encounter) resources.Encounter = resources.Encounter.sort((a, b) => {
                        let x = PeriodStart(a.period)
                        let y = PeriodStart(b.period)
                        if (x > y) return -1
                        if (y > x) return 1
                        return 0
                    })
                })
                return <div>
                    <div className='All-Row All-Flex-Wrap'>
                        <div className='All-Button All-Button-Save All-Flex-Wrap' onClick={() => this.handleLongRec()}>
                            <div style={{ textAlign: 'center' }}>{this.state.longRec ? 'Resources View' : 'Chronological View'}</div>
                        </div>
                    </div>
                    {
                        resources.Patient && resources.Patient.map((p, pidx) => {
                            return <Patient key={`patient-${pidx}`} resource={p} />
                        })
                    }
                    {
                        Object.keys(resources).filter(r => r !== 'Patient').sort((a, b) => {
                            if (a > b) return 1
                            if (b > a) return -1
                            return 0
                        }).map((res, residx) => {
                            return <div key={`res-${residx}`}>
                                <div className='All-Row All-Flex-Left'>
                                    <div className='All-Divider-Text'><span style={{ marginRight: '5px' }}>{this.getIcon(res)}</span>{res}</div>
                                    <div className='All-Divider'></div>
                                    <div className='All-Divider-Button' onClick={() => this.handleMore(res)}>{this.state.more.indexOf(res) > -1 ? 'More' : 'Less'}</div>
                                </div>
                                {
                                    this.state.more.indexOf(res) === -1 && <div className='All-Row All-Flex-Wrap'>
                                        {
                                            resources[res].map((r, ridx) => {
                                                switch (res) {
                                                    case 'AllergyIntolerance':
                                                        return <AllergyIntolerance key={`${res}-${ridx}`} resource={r} />
                                                    case 'Appointment':
                                                        return <Appointment key={`${res}-${ridx}`} resource={r} />
                                                    case 'DiagnosticReport':
                                                        return <DiagnosticReport key={`${res}-${ridx}`} resource={r} onSelect={this.handleGetEncounter} />
                                                    case 'Encounter':
                                                        return <Encounter key={`${res}-${ridx}`} resource={r} onSelect={this.handleGetEncounter} />
                                                    case 'CarePlan':
                                                        return <CarePlan key={`${res}-${ridx}`} resource={r} />
                                                    case 'CareTeam':
                                                        return <CareTeam key={`${res}-${ridx}`} resource={r} />
                                                    case 'Condition':
                                                        return <Condition key={`${res}-${ridx}`} resource={r} />
                                                    case 'Coverage':
                                                        return <Coverage key={`${res}-${ridx}`} resource={r} />
                                                    case 'Device':
                                                        return <Device key={`${res}-${ridx}`} resource={r} />
                                                    case 'Immunization':
                                                        return <Immunization key={`${res}-${ridx}`} resource={r} />
                                                    case 'MedicationRequest':
                                                        return <MedicationRequest key={`${res}-${ridx}`} resource={r} />
                                                    case 'Observation':
                                                        return <Observation key={`${res}-${ridx}`} resource={r} />
                                                    case 'Organization':
                                                        return <Organization key={`${res}-${ridx}`} resource={r} />
                                                    case 'Practitioner':
                                                        return <Practitioner key={`${res}-${ridx}`} resource={r} />
                                                    case 'Procedure':
                                                        return <Procedure key={`${res}-${ridx}`} resource={r} />
                                                    case 'ServiceRequest':
                                                        return <ServiceRequest key={`${res}-${ridx}`} resource={r} />
                                                    default:
                                                        return <TBD key={`${res}-${ridx}`} resource={r} />
                                                }
                                            })
                                        }
                                    </div>
                                }
                            </div>
                        })
                    }
                </div>
            }
        }
    }

    getEncounter() {
        if (this.state.encounter && this.state.encounter.entry) {
            let resources = {}
            this.state.encounter.entry.forEach(res => {
                if (resources[res.resource.resourceType]) {
                    resources[res.resource.resourceType].push(res.resource)
                } else {
                    resources[res.resource.resourceType] = [res.resource]
                }
            })
            return <div>
                {
                    resources.Encounter.map((p, pidx) => {
                        return <EncounterBig key={`encounter-${pidx}`} resource={p} />
                    })
                }
                {
                    Object.keys(resources).filter(r => r !== 'Encounter').sort((a, b) => {
                        if (a > b) return 1
                        if (b > a) return -1
                        return 0
                    }).map((res, residx) => {
                        return <div key={`res-${residx}`}>
                            <div className='All-Row All-Flex-Left'>
                                <div className='All-Divider-Text'><span style={{ marginRight: '5px' }}>{this.getIcon(res)}</span>{res}</div>
                                <div className='All-Divider'></div>
                                <div className='All-Divider-Button' onClick={() => this.handleMore(res)}>{this.state.more.indexOf(res) > -1 ? 'More' : 'Less'}</div>
                            </div>
                            {
                                this.state.more.indexOf(res) === -1 && <div className='All-Row All-Flex-Wrap'>
                                    {
                                        resources[res].map((r, ridx) => {
                                            switch (res) {
                                                case 'AllergyIntolerance':
                                                    return <AllergyIntolerance key={`${res}-${ridx}`} resource={r} />
                                                case 'Appointment':
                                                    return <Appointment key={`${res}-${ridx}`} resource={r} />
                                                case 'DiagnosticReport':
                                                    return <DiagnosticReport key={`${res}-${ridx}`} resource={r} onSelect={this.handleGetEncounter} />
                                                case 'Encounter':
                                                    return <Encounter key={`${res}-${ridx}`} resource={r} onSelect={this.handleGetEncounter} />
                                                case 'CarePlan':
                                                    return <CarePlan key={`${res}-${ridx}`} resource={r} />
                                                case 'CareTeam':
                                                    return <CareTeam key={`${res}-${ridx}`} resource={r} />
                                                case 'Condition':
                                                    return <Condition key={`${res}-${ridx}`} resource={r} />
                                                case 'Coverage':
                                                    return <Coverage key={`${res}-${ridx}`} resource={r} />
                                                case 'Device':
                                                    return <Device key={`${res}-${ridx}`} resource={r} />
                                                case 'Immunization':
                                                    return <Immunization key={`${res}-${ridx}`} resource={r} />
                                                case 'MedicationRequest':
                                                    return <MedicationRequest key={`${res}-${ridx}`} resource={r} />
                                                case 'Observation':
                                                    return <Observation key={`${res}-${ridx}`} resource={r} />
                                                case 'Organization':
                                                    return <Organization key={`${res}-${ridx}`} resource={r} />
                                                case 'Patient':
                                                    return <PatientSmall key={`${res}-${ridx}`} resource={r} />
                                                case 'Practitioner':
                                                    return <Practitioner key={`${res}-${ridx}`} resource={r} />
                                                case 'Procedure':
                                                    return <Procedure key={`${res}-${ridx}`} resource={r} />
                                                case 'ServiceRequest':
                                                    return <ServiceRequest key={`${res}-${ridx}`} resource={r} />
                                                default:
                                                    return <TBD key={`${res}-${ridx}`} resource={r} />
                                            }
                                        })
                                    }
                                </div>
                            }
                        </div>
                    })
                }
            </div>
        }
    }

    getPatientsCards() {
        return <div className='All-Flex-Wrap'>
            {
                this.state.patients.map((p, pidx) => {
                    return <PatientCard key={`pat-${pidx}`} patient={p.resource} onSelect={this.handleGetPatient} />
                })
            }
        </div>
    }

    render() {
        //console.log(this.props, this.state)
        return <div ref={this.ScrollUp} className='All-Container'>
            <TopMenu user={this.props.user ? { firstName: this.props.user.firstName, image: this.props.user.image } : null} mode={this.props.mode} onBack={this.handleBack} onPref={this.handlePrefSelected} />
            <div className='All-Row All-Flex-Spread'>
                <div></div>
                <img src={Banner} alt="HIT Clinical Viewer" height={"40px"} />
            </div>
            <div className='Home-Menu-Container'>
                {this.getServer()}
                <div className='All-Row All-Flex-Left'>
                    <div className='All-Checkbox' style={{ marginRight: '5px' }}>
                        <input value="sort" type="checkbox" checked={this.state.sort} onChange={(event) => this.handleCheckChanged(event)} />
                        <span className='All-Checkbox-Text'>Sort</span>
                    </div>
                    <div className='All-Flex' style={{ width: '145px' }}>
                        <div className='All-Checkbox-Text' style={{ marginRight: '5px', marginTop: '5px' }}>Name</div>
                        <Form.Group controlId="name">
                            <Form.Control
                                placeholder="Mbr Last Name"
                                type="text"
                                value={this.state.name}
                                onChange={this.handleChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='All-Flex' style={{ marginLeft: '5px', width: '170px' }}>
                        <div className='All-Checkbox-Text' style={{ marginTop: '5px', width: '75px' }}>MBR ID</div>
                        <Form.Group controlId="mbrid">
                            <Form.Control
                                placeholder="Member ID"
                                type="text"
                                value={this.state.mbrid}
                                onChange={this.handleChange}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className='All-Row All-Flex-Wrap'>
                    <div className='All-Button All-Button-Save All-Flex-Spread' onClick={() => this.handleGetPatients()}>
                        <div className='All-Btn-Icon All-Spin'>{this.state.isWorking && <TfiReload />}</div>
                        <div>Submit</div>
                        <div className='All-Btn-Icon All-Spin'>{this.state.isWorking && <TfiReload />}</div>
                    </div>
                </div>
                {(this.state.qry || this.state.eqry) && <div className='All-Row All-Flex'><div className='All-Info' onClick={() => this.handleCopy()}>{`Last Query: ${this.state.eqry || this.state.qry}`}</div><span style={{ marginLeft: '5px', color: '#b3b3b3' }} className='All-Icon'>{this.state.copied ? <LuCopyCheck /> : <LuCopy />}</span></div>}
                <div className='All-Row All-Flex-Wrap'><div className='All-Text'>{this.state.total && `Total: ${this.state.total}`}</div></div>
                {this.state.splash && this.getSplash()}
                {this.state.bounce && this.getBounce()}
                {this.state.displayMsg && this.getMessage()}
                {!this.state.encounter && !this.state.patient && this.state.patients && this.state.patients.length > 0 && <div className='All-Row'>{this.getPatientsCards()}</div>}
                {this.state.encounter && this.getEncounter()}
                {this.state.patient && !this.state.encounter && this.getPatient()}

                {this.state.encounter && <div className='All-Row All-Flex-Spread'>
                    <div className='All-Flex'>
                        <div style={{ marginRight: '10px', color: '#ff0000' }} className='All-Big-Icon' onClick={() => this.handleBackToPatient()}><FaArrowCircleLeft /></div>
                        {this.state.encounter.link && this.state.encounter.link.findIndex(l => l.relation === 'previous') > -1 && <div className='All-Big-Icon' onClick={() => this.handleGetEncounter(null, this.state.encounter.link[this.state.encounter.link.findIndex(l => l.relation === 'previous')])}><FaArrowCircleLeft /></div>}
                    </div>
                    <div></div>
                    {this.state.encounter.link && this.state.encounter.link.findIndex(l => l.relation === 'next') > -1 && <div className='All-Big-Icon' onClick={() => this.handleGetEncounter(null, this.state.encounter.link[this.state.encounter.link.findIndex(l => l.relation === 'next')])}><FaArrowCircleRight /></div>}
                </div>}

                {!this.state.encounter && this.state.patient && !this.state.longRec && <div className='All-Row All-Flex-Spread'>
                    <div className='All-Flex'>
                        <div style={{ marginRight: '10px', color: '#ff0000' }} className='All-Big-Icon' onClick={() => this.handleBackToList()}><FaArrowCircleLeft /></div>
                        {this.state.patient.link && this.state.patient.link.findIndex(l => l.relation === 'previous') > -1 && <div className='All-Big-Icon' onClick={() => this.handleGetPatient(null, this.state.patient.link[this.state.patient.link.findIndex(l => l.relation === 'previous')])}><FaArrowCircleLeft /></div>}
                    </div>
                    <div></div>
                    {this.state.patient.link && this.state.patient.link.findIndex(l => l.relation === 'next') > -1 && <div className='All-Big-Icon' onClick={() => this.handleGetPatient(null, this.state.patient.link[this.state.patient.link.findIndex(l => l.relation === 'next')])}><FaArrowCircleRight /></div>}
                </div>}
                {!this.state.patient && !this.state.encounter && <div className='All-Row All-Flex-Spread'>
                    <div className={`All-Big-Icon${this.state.isPreviousing ? ' All-Spin' : ''}`} onClick={() => this.handleGetPatients(this.state.previous)}>{this.state.previous ? (this.state.isPreviousing ? <TfiReload /> : <FaArrowCircleLeft />) : null}</div>
                    <div></div>
                    <div className={`All-Big-Icon${this.state.isNexting ? ' All-Spin' : ''}`} onClick={() => this.handleGetPatients(this.state.next)}>{this.state.next ? (this.state.isNexting ? <TfiReload /> : <FaArrowCircleRight />) : null}</div>
                </div>}
            </div>
        </div>
    }

}

export default withRouter(Home)
